var configs = {
    classNames: {
        inset: 'Inset',
        nolistview: 'NoListview',
        nopanel: 'NoPanel',
        panel: 'Panel',
        selected: 'Selected',
        vertical: 'Vertical'
    },
    language: null,
    openingInterval: 25,
    panelNodetype: ['ul', 'ol', 'div'],
    transitionDuration: 400
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/core/oncanvas/_configs.js
// module id = 93
// module chunks = 0